import { render } from "./systemAlert.vue?vue&type=template&id=834cbc4c&scoped=true&ts=true"
import script from "./systemAlert.vue?vue&type=script&lang=ts"
export * from "./systemAlert.vue?vue&type=script&lang=ts"

import "./systemAlert.vue?vue&type=style&index=0&id=834cbc4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-834cbc4c"]])

export default __exports__